import React from "react";
import { useTranslation } from "react-i18next";
import { DropDownItem } from "../../../models/DropDownItem";

export type Props = {
    item:DropDownItem,
    isChecked:boolean,
    handleChange:(item:DropDownItem)=> void,
    displayKey:boolean,
    enableTranslate:boolean
}
const Checkbox:React.FC<Props> = ({ item,isChecked,handleChange, displayKey,enableTranslate }) => {
     const {t} = useTranslation();
    let classes = (isChecked ? ' active': '');
    const onChange = () => {
        handleChange(item)
      };
    function provideNameToDisplay(item:DropDownItem):string{
      if(enableTranslate){
        return displayKey?t(item.Element.key)+" ("+item.Element.key+")":t(item.Element.key);
      }
      else{
          return item.Element.name
      }
    }
    return (
      <div className={`checkbox-wrapper${classes}`}>
        <label htmlFor={item.Element.key} >
          <span>{provideNameToDisplay(item)}</span>
        </label>
        <input id={item.Element.key} aria-checked="false" type="checkbox" checked={isChecked} onChange={onChange}/>
      </div>
    );
  };
  export default Checkbox;